import Button from '../../../components/base/Button';

export default function ExpertiseSection() {
  const expertiseAreas = [
    {
      icon: 'ri-quill-pen-line',
      title: 'High-Quality Writing',
      description: 'We are committed to developing content that delivers results.',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast and Reliable Turnaround',
      description: 'We deliver compelling content efficiently without sacrificing quality.',
    },
    {
      icon: 'ri-team-line',
      title: 'Collaborative Approach',
      description: 'We work with you to develop content that aligns with your vision and goals.',
    }
  ];

  return (
    <section className="py-16 bg-white" aria-labelledby="expertise-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm lg:text-base tracking-widest text-gray-600 font-medium uppercase mb-4 block">
            OUR COMMITMENT TO YOU
          </span>
          <h2 id="expertise-heading" className="text-4xl font-bold text-gray-900 mb-4">
            Let's Bring Your Vision to Life - One Word at a Time!
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" role="list" aria-label="ProEditions expertise areas">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="text-center" role="listitem">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6" aria-hidden="true">
                <i className={`${area.icon} text-4xl text-gray-700`}></i>
              </div>
              
              <h3 className="text-xl font-medium text-gray-900 mb-4">
                {area.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed font-light">
                {area.description}
              </p>
              
              {area.cta && (
                <button className="text-sm text-gray-700 border-b border-gray-300 hover:border-gray-700 transition-colors font-light whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1a4d2e] rounded-md px-2 py-1">
                  {area.cta}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
